import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes without conflicts.
 * Use instead of template literals whenever classes are conditional.
 *
 * @example
 * cn('px-4 py-2', isActive && 'bg-zinc-900', className)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
